/* eslint-disable no-multi-spaces */
import character from './character'
import goods     from './goods'
import news      from './news'
import special   from './special'
import staff     from './staff'
import story     from './story'
import video     from './video'
import bd     from './bd'

// razbliuto
import razcharacter from './razbliuto/character'
import razstaff     from './razbliuto/staff'
import razstory     from './razbliuto/story'
/* eslint-enable */

export default {
  /* eslint-disable no-undef */
  news: news.reverse(),
  story: story,
  goods: goods,
  staff: staff,
  character: character,
  video: video,
  special: special,
  bd,
  /* eslint-enable no-undef */
  onair: {
    tv: [
      {
        name: 'フジテレビ',
        date: '7月8日より',
        time: '毎週水曜24:55〜25:25'
      },
      {
        name: '関西テレビ',
        date: '7月9日より',
        time: '毎週木曜25:55〜26:25'
      },
      {
        name: '東海テレビ',
        date: '7月11日より',
        time: '毎週土曜25:45〜26:15'
      },
      {
        name: 'テレビ西日本',
        date: '7月8日より',
        time: '毎週水曜25:55〜26:25'
      },
      {
        name: '北海道文化放送',
        date: '7月12日より',
        time: '毎週日曜25:10〜25:40'
      },
      {
        name: 'BSフジ',
        date: '7月15日より',
        time: '毎週水曜24:00〜24:30'
      }
    ],
    nf: [
      {
        name: 'CASE 1（1話～5話）',
        date: '配信中'
      },
      {
        name: 'CASE 2（6話～10話）',
        date: '配信中'
      },
      {
        name: 'CASE 3（11話～14話）',
        date: '配信中'
      },
      {
        name: 'CASE 4（15話～23話）',
        date: '配信中'
      }
    ]
  },
  razstaff,
  razcharacter,
  razstory
}



// WEBPACK FOOTER //
// ./src/data/documents.js